import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class configArticlePages_template extends vnTemplate{
    protected audioReaderContentTypes: multipleSelector_template;

    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string{

        return  /*html*/`  
        <div class="w-form w-form-large">
            <div class="form-header">
                <h3 class="form-title icon i-article">Article Page config</h3>
            </div>
            <strong class="form-sub-title" style="margin-top: 2rem">General Options</strong>
            <div class="w-form-body">
                             
                <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="bc" data-bind="checked: isBreadcrumbEnable">
                        <label class="form-label icon i-check" for="bc"><span>Breadcrumb Enabled</span></label>
                    </div>
                </div>

                 <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="rns" data-bind="checked: isReadNextEnable">
                        <label class="form-label icon i-check" for="rns"><span>Read Next Section Enabled</span></label>
                    </div>
                </div>
                
                <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="timeUpdate" data-bind="checked: isTimeUpdateEnable">
                        <label class="form-label icon i-check" for="timeUpdate"><span>Enable Same-Day Article Time Updates</span></label>
                    </div>
                </div>
              
         
                <div class="form-body">
                    <div class="form-group row">
                        <label for="siteDefaultListOrder" class="form-label">Default List Numbering</label>
                        <select name="" id="siteDefaultListOrder" data-bind="value: defaultListOrder">
                            <option value="ascending">Ascending</option>
                            <option value="descending">Descending</option>
                            <option value="none">None</option>
                        </select>
                    </div>
                </div>
                
                <div class="form-body">
                    <div class="form-group row">
                        <label for="key-takeaway" class="form-label">Key Takeaway Title</label>
                        <input type="text" data-bind="value: keyTakeawayTitle" class="input-text">
                    </div>
                </div>

                <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="pollDynamicPlacement" data-bind="checked: isPollDynamicPlacementOnByDefault">
                        <label class="form-label icon i-check" for="pollDynamicPlacement"><span>Enable Poll Dynamic Placement Based on Sentinel Avg. Scroll Depth % by Default</span></label>
                    </div>
                </div>

                <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="quizDynamicPlacement" data-bind="checked: isQuizDynamicPlacementOnByDefault">
                        <label class="form-label icon i-check" for="quizDynamicPlacement"><span>Enable Quiz Dynamic Placement Based on Sentinel Avg. Scroll Depth % by Default</span></label>
                    </div>
                </div>
             
                
                
            </div>    
            <div class="w-form-body">
                <div class="form-body full-width">
                    <strong class="form-sub-title">Audio Reader Options</strong>
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group">
                                <input type="checkbox" id="audioReaderDefault" data-bind="checked: isAudioReaderDefaultEnabled">
                                <label class="form-label icon i-check" for="audioReaderDefault"><span>Enable Audio Reader by Default</span></label>
                            </div>
                            <div class="form-group" data-bind="visible: isAudioReaderDefaultEnabled">
                                <legend class="form-legend">Content Types</legend>
                                ${this.audioReaderContentTypes.getHtmlBuild()}
                                <p class="form-label">Leave empty to enable Audio Reader by default for all content types.</p>
                            </div>
                        </div>
                    </div>

                    <strong class="form-sub-title">Social Media Options</strong>
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group">
                                <input type="checkbox" id="ta" data-bind="checked: isTrueAnthemEnable">
                                <label class="form-label icon i-check" for="ta"><span>True Anthem Enabled</span></label>
                            </div>
                        </div>
                    </div>
                    
                    <table class="list-action social-media">
                        <thead>
                            <tr>
                                <th></th>
                                <th><span>ARTICLE HEADER</span></th>
                                <th><span>ARTICLE FOOTER</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td class="align-center">
                                    <button data-bind="event: {click: toggleSelectAll('share_links_top', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="event: {click: toggleSelectAll('share_links_top', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                                <td class="align-center">
                                    <button data-bind="event: {click: toggleSelectAll('share_links_bottom', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="event: {click: toggleSelectAll('share_links_bottom', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                            </tr>
                        </tbody>
                        <tbody data-bind="foreach: article_social_share_links">
                            <tr> 
                                <td><span class="form-label" data-bind="text: $data.type, css: $data.iconClass"></span></td>
                                <td class="align-center">
                                    <div>
                                        <input type="checkbox" data-bind="checked: $data.enabled.top, attr: {id: 'article_social_share_links_top_' + $index()}">
                                        <label class="form-label icon i-check" data-bind="attr: {for: 'article_social_share_links_top_' + $index()}"><span>Enabled</span></label>
                                    </div>
                                </td>
                                <td class="align-center">
                                    <div>
                                        <input type="checkbox" data-bind="checked: $data.enabled.bottom, attr: {id: 'article_social_share_links_bottom_' + $index()}">
                                        <label class="form-label icon i-check" data-bind="attr: {for: 'article_social_share_links_bottom_' + $index()}"><span>Enabled</span></label>
                                    </div>
                                </td>
                            </tr>  
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div class="form-footer">
                <button data-bind="event: {click: onClickCancelArticleSocialMedia}" class="btn " type="button">Cancel</button>
                <button data-bind="event: {click: onClickSaveArticleSocialMedia}" class="btn highlight" type="button">Save</button>
            </div>
          
        </div>
            `;
    }

    //
    // implementation of base class [vnTemplate]
    protected getTemplateName(): string{
        return "configArticlePages_template";
    }

    //
    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel(){

        // define the viewModel data/ functions
        let self = this;

        return  {
            article_social_share_links: ko.observableArray([]),
            isBreadcrumbEnable: ko.observable(),
            isTrueAnthemEnable: ko.observable(false),
            isReadNextEnable: ko.observable(false),
            isTimeUpdateEnable: ko.observable(false),
            defaultListOrder: ko.observable(""),
            keyTakeawayTitle: ko.observable(""),
            additionalCreditEnabled: ko.observable(false),
            isAudioReaderDefaultEnabled: ko.observable(false),
            selectedAudioReaderDefaultContentTypes: ko.observableArray([]),
            isPollDynamicPlacementOnByDefault: ko.observable(false),
            isQuizDynamicPlacementOnByDefault: ko.observable(false),
            onClickCancelArticleSocialMedia: function () {
                self.onClickCancelArticleSocialMedia()
            },
            onClickSaveArticleSocialMedia: function () {
                self.onClickSaveArticleSocialMedia()
            },
            toggleSelectAll: function (col, checked){
                self.toggleSelectAll(col,checked)
            }
        };
    }

    public set_article_social_share_links(obj) {
        this.getTemplateViewModel().article_social_share_links(obj)
    }

    public set_isBreadcrumbEnable(bool) {
        this.getTemplateViewModel().isBreadcrumbEnable(bool)
    }

    public set_isTrueAnthemEnable(bool) {
        this.getTemplateViewModel().isTrueAnthemEnable(bool)
    }

    public set_isReadNextEnable(bool) {
        this.getTemplateViewModel().isReadNextEnable(bool)
    }

    public set_additionalCreditEnabled(bool) {
        this.getTemplateViewModel().additionalCreditEnabled(bool)
    }

    public set_isTimeUpdateEnable(bool) {
        this.getTemplateViewModel().isTimeUpdateEnable(bool)
    }

    public set_defaultListOrder(obj) {
        this.getTemplateViewModel().defaultListOrder(obj);
    }

    public set_keyTakeawayTitle(title) {
        this.getTemplateViewModel().keyTakeawayTitle(title);
    }

    public set_isPollDynamicPlacementOnByDefault(bool) {
        this.getTemplateViewModel().isPollDynamicPlacementOnByDefault(bool);
    }

    public set_isQuizDynamicPlacementOnByDefault(bool) {
        this.getTemplateViewModel().isQuizDynamicPlacementOnByDefault(bool);
    }

    protected onClickSaveArticleSocialMedia(): any {

        let articlePagesSettings = {
            'social_share_links': this.getTemplateViewModel().article_social_share_links(),
            'isBreadcrumbEnable': this.getTemplateViewModel().isBreadcrumbEnable(),
            'isTrueAnthemEnable': this.getTemplateViewModel().isTrueAnthemEnable(),
            'isReadNextEnable': this.getTemplateViewModel().isReadNextEnable(),
            'additionalCreditEnabled': this.getTemplateViewModel().additionalCreditEnabled(),
            'isTimeUpdateEnable': this.getTemplateViewModel().isTimeUpdateEnable(),
            'defaultListOrder': this.getTemplateViewModel().defaultListOrder,
            'keyTakeawayTitle': this.getTemplateViewModel().keyTakeawayTitle,
            'isAudioReaderDefaultEnabled': this.getTemplateViewModel().isAudioReaderDefaultEnabled(),
            'audioReaderDefaultContentTypes': this.getTemplateViewModel().selectedAudioReaderDefaultContentTypes(),
            'isPollDynamicPlacementOnByDefault': this.getTemplateViewModel().isPollDynamicPlacementOnByDefault(),
            'isQuizDynamicPlacementOnByDefault': this.getTemplateViewModel().isQuizDynamicPlacementOnByDefault(),
        }
        this.caller.saveData(articlePagesSettings, 'article_pages_settings')
    }

    protected onClickCancelArticleSocialMedia(): any {
        this.caller.cancelArticleSocialMedia()
    }

    protected toggleSelectAll(col, checked){
        let temp = this.getTemplateViewModel().article_social_share_links();
        if(col == "share_links_top"){
            for(let e of temp){
                e.enabled.top = checked
            }
        }
        else if(col == "share_links_bottom"){
            for(let e of temp){
                e.enabled.bottom = checked
            }
        }
        this.getTemplateViewModel().article_social_share_links([])
        this.getTemplateViewModel().article_social_share_links(temp)

    }

    public set_isAudioReaderDefaultEnabled(bool) {
        this.getTemplateViewModel().isAudioReaderDefaultEnabled(bool)
    }

    protected initPartial(): void {
        this.audioReaderContentTypes = new multipleSelector_template("articlePages_audioReaderContentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.audioReaderContentTypes.setFilterContainerClass('margin-neg');
        this.audioReaderContentTypes.setSelectAllEnabled(true);
        this.audioReaderContentTypes.setSearchEnabled(true);
        this.audioReaderContentTypes.setTagContainerId('selected_audioReaderContentTypes');
        this.audioReaderContentTypes.setLabel("Content Types");
    }

    public setContentTypeOptions(contentTypes): void {
        this.audioReaderContentTypes.setItems(contentTypes || []);
    }

    public set_audioReaderDefaultContentTypes(contentTypes): void {
        const selected = contentTypes || [];
        this.getTemplateViewModel().selectedAudioReaderDefaultContentTypes(selected);
        // The multi-selector stores full content type objects so the saved config
        // has labels available, but selection comparison later uses their ids.
        this.audioReaderContentTypes.setSelectedItems(selected);
    }

    public updateSelectedAudioReaderDefaultContentTypes(): void {
        const selectedIds = this.audioReaderContentTypes.getSelectedItems();
        const allContentTypes = this.audioReaderContentTypes.getItems();
        // Save full objects instead of bare ids to match the assistant/config
        // dropdown convention already used elsewhere in Emaki.
        const selectedContentTypes = allContentTypes.filter((contentType) => selectedIds.some((id) => String(id) === String(contentType.id)));
        this.getTemplateViewModel().selectedAudioReaderDefaultContentTypes(selectedContentTypes);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configArticlePages_template.ts